/*
 * Author: nihiue@gmail.com
 * Aug, 2017
 */

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

function easeInOut(x) {
  if (x >= 1) {
    return 1;
  }
  if (x <= 0) {
    return 0;
  }
  return x < 0.5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
}

function applyScroll(el, d) {
  if (!el) {
    window.scrollTo(0, d);
  } else {
    el.scrollTop = d;
  }
}

function performRafScroll({
  container,
  startPos,
  endPos,
  duration
}) {
  if (startPos === endPos) {
    return;
  }
  const delta = endPos - startPos;
  let startTime = null;

  function rafWorker(timestamp) {
    if (startTime === null) {
      startTime = timestamp;
    } else {
      const elapsed = timestamp - startTime;
      const pos = startPos + Math.ceil(easeInOut(elapsed / duration) * delta);
      applyScroll(container, pos);
      if (elapsed >= duration || Math.abs(pos - endPos) <= 2) {
        return;
      }
    }
    window.requestAnimationFrame(rafWorker);
  }
  window.requestAnimationFrame(rafWorker);
}

export function smoothScrollTo(anchor, opt) {
  if (!anchor) {
    return;
  }
  if (!window.requestAnimationFrame) {
    anchor.scrollIntoView();
    return;
  }
  const container = opt && opt.container;
  const duration = (opt && opt.duration) || 500;
  const offset = (opt && opt.offset) || 30;
  const anchorRect = anchor.getBoundingClientRect();
  if (!container) {
    const scrollTop = Math.max(window.document.documentElement.scrollTop, window.document.body.scrollTop);
    performRafScroll({
      startPos: scrollTop,
      endPos: scrollTop + anchorRect.top - offset,
      duration
    });
  } else {
    const containerRect = container.getBoundingClientRect();
    performRafScroll({
      container,
      startPos: container.scrollTop,
      endPos: container.scrollTop + anchorRect.top - containerRect.top - offset,
      duration
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/scroll.js